import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";
import { useQuery } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";

export const getUserSubscription = async () => {
  const userId = await getUserId();
  const { data, error } = await supabase.rpc("get_relevant_user_subscription", { user_uuid: userId });

  if (error) {
    Sentry.captureException(error);
    throw new Error(error.message);
  }

  const subscription = {
    id: data?.[0].subscription_id,
    type: data?.[0].type,
    startDate: data?.[0].start_date,
  };

  return subscription;
};

export const useSubscription = () => {
  return useQuery({
    queryKey: ["subscription"],
    queryFn: getUserSubscription,
  });
};
